import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SentinelService } from '@bannerflow/sentinel';
import { UINewThemeService } from '@bannerflow/ui';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet],
    templateUrl: './app.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './app.component.scss'
})
export class AppComponent {
    sentinel = inject(SentinelService);

    private readonly uiThemeService: UINewThemeService = inject(UINewThemeService);

    constructor() {
        this.uiThemeService.enableNewTheme();
    }
}
